'use client';

import { VideoIcon } from 'lucide-react';
import Image from 'next/image';

import TextSplitter from '~/components/molecules/TextSplitter';
import { GalleryMediaSchema } from '~/lib/api/fragments/gallery-media';
import { cn } from '~/lib/utils/classname';

interface Props {
  media: GalleryMediaSchema;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  ref?: (node: HTMLElement | null) => void;
}

const PropertyGalleryItem: React.FC<Props> = ({ media, onClick, ref }) => (
  <button
    className={cn(
      'group/gallery-button relative isolate aspect-120/180 h-full w-full cursor-pointer',
      {
        'bg-brand-quinary/25': media.node.mediaType === 'file',
      }
    )}
    type="button"
    onClick={onClick}
    ref={ref}
  >
    {media.node.mediaType === 'image' && (
      <Image
        src={media.node.sourceUrl}
        alt={media.node.altText}
        width={360}
        height={540}
        placeholder={media.node.blurDataUrl ? 'blur' : 'empty'}
        blurDataURL={media.node.blurDataUrl || undefined}
        className="absolute top-0 left-0 h-full w-full object-cover"
        unoptimized
      />
    )}

    {media.node.mediaType === 'file' && (
      <>
        {media.node.featuredImage?.node && (
          <Image
            src={media.node.featuredImage.node.sourceUrl}
            alt={media.node.featuredImage.node.altText}
            width={360}
            height={540}
            className="absolute top-0 left-0 h-full w-full object-cover"
            unoptimized
          />
        )}

        <div className="absolute top-0 left-0 z-10 grid h-full w-full place-items-end p-4 text-white transition-colors duration-500 group-hover/gallery-button:text-white/0 group-focus-visible/gallery-button:text-white/0">
          <VideoIcon />
        </div>
      </>
    )}

    <div className="bg-brand-secondary/0 group-hover/gallery-button:bg-brand-secondary/50 group-focus-visible/gallery-button:bg-brand-secondary/50 pointer-events-none absolute top-0 left-0 grid h-full w-full place-items-center text-white transition-colors duration-500">
      <TextSplitter
        text="Voir"
        generateLetterProps={({ index }) => ({
          className:
            'relative inline-block translate-y-1 opacity-0 transition-all duration-500 group-hover/gallery-button:translate-y-0 group-hover/gallery-button:opacity-100 group-focus-visible/gallery-button:translate-y-0 group-focus-visible/gallery-button:opacity-100',
          style: {
            transitionDelay: `${index * 0.025}s`,
          },
        })}
      />
    </div>
  </button>
);

export default PropertyGalleryItem;
